import MDEditor from '@uiw/react-md-editor';
import remarkGfm from 'remark-gfm';

type Props = {
    value: string;
    onChange: (value: string) => void;
    height?: number;
    placeholder?: string;
    fill?: boolean; // stretch to fill the available viewport height
};

// Reusable markdown editor with a formatting toolbar and a live preview that
// renders the same GFM markdown the public pages show — so the operator sees
// the real shape of the text while writing.
export default function MarkdownEditor({ value, onChange, height = 320, placeholder, fill }: Props) {
    return (
        <div className={"mdEditor" + (fill ? " fill" : "")} data-color-mode="light">
            <MDEditor
                value={value}
                onChange={v => onChange(v ?? "")}
                height={height}
                preview="live"
                visibleDragbar={!fill}
                textareaProps={{ placeholder }}
                previewOptions={{ remarkPlugins: [remarkGfm] }}
            />
        </div>
    );
}
